import { VirtualRefinements } from './VirtualRefinements';
import { VirtualSearchBox } from './VirtualSearchBox';
import { VirtualSortBy } from './VirtualSortBy';
import { useAppContext } from '../../../utilities/context/static/AppContext';
import { HIDDEN_URL_FACETS } from '~/utilities/constants/algolia';
import { useProductListContext } from '~/utilities/context/static/ProductListContext';

export const VirtualAlgoliaComponents = () => {
  const { lang } = useAppContext();
  const { categoryDetails: { visibleFacetsV2 } = {}, visibleFacetsList } = useProductListContext();
  const hiddenFacets = [...HIDDEN_URL_FACETS.values()].filter(
    ({ code }) => !visibleFacetsList.has(code)
  );

  return (
    <>
      <VirtualSearchBox />
      <VirtualSortBy />

      {[...(visibleFacetsV2?.filter(Boolean) ?? []), ...hiddenFacets].map(facet => (
        <VirtualRefinements
          key={facet.code}
          attribute={facet?.localized ? `${facet.code}.${lang}` : facet.code}
        />
      ))}
    </>
  );
};
